var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { VIEW_FULLSCREEN, VIEW_WINDOW } from '../constants/streaming';
export default function fullscreen(state, action, fullState) {
    if (state === void 0) { state = { fullscreen: false, stream_id: "", uid: 0, picture_in_picture_left: "100px", picture_in_picture_top: "100px" }; }
    if (action.type == VIEW_FULLSCREEN) {
        var uid = fullState.videoStreams[action.stream_id].user.uid;
        return __assign(__assign({}, state), { fullscreen: true, stream_id: action.stream_id, uid: uid });
    }
    if (action.type == VIEW_WINDOW) {
        return __assign(__assign({}, state), { uid: 0, fullscreen: false, stream_id: "" });
    }
    if (action.type == "FULLSCREEN_POP_MOVE") {
        return __assign(__assign({}, state), { picture_in_picture_top: action.top, picture_in_picture_left: action.left });
    }
    return state;
}



//////////////////
// WEBPACK FOOTER
// ./src/reducers/fullscreen.ts
// module id = 718
// module chunks = 0